import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";
import Column from "apps/website/components/layout/Column/Column";
import Container from "apps/website/components/layout/Container/Container";
import Grid from "apps/website/components/layout/Grid/Grid";
import Section from "apps/website/components/layout/Section/Section";
import { themeRootClassMap } from "apps/website/maps/Theme.map";
import cx from "apps/website/utils/misc/cx";

export default function SectionCatsAreCarnivoresVariant() {
  return (
    <Section theme="dark" className={themeRootClassMap.dark}>
      <Container>
        <Grid gap="lg">
          <Column align="center" justify="center">
            <TextTitle
              tag="h2"
              size={1}
              align="center"
              data-testid="SectionCatsAreCarnivoresVariant-title"
            >Cats are carnivores. so why does cat food have so little* meat?</TextTitle>
            <div
              data-theme="brand"
              className={
                cx(
                  "-rotate-1 px-2 w-fit",
                  themeRootClassMap.brand,

                )
              }
            >
              <TextTitle size={3} data-testid="SectionCatsAreCarnivoresVariant-tag">*As little as 4%</TextTitle>
            </div>
          </Column>
        </Grid>
      </Container>
    </Section>
  );
}
